import type { CvtDiagnosticEntity, VehicleGraphData } from '@packages/domain/cvt';
import type { PlotlyPdfExportOptions } from '../plotly-pdf-export';
import { generateCvtPlotConfigs } from '@web/utils/generate-cvt-plots';
import { getDisplayDate, getDisplayValue } from '@web/utils';
import { getSymptomsTablePdfColumns, getSymptomsTablePdfData } from '../cvt-report-table';
import { DATE_FORMAT } from '@web/config/constants';

const PDF_TITLE = 'CVT Diagnostic Report';

function getCvtReportMetaDetails(data: CvtDiagnosticEntity) {
    return [
        { label: 'VIN ', value: getDisplayValue(data?.vin) },
        { label: 'SOA Diagnostic ID', value: getDisplayValue(data?.diagnosticId) },
        { label: 'Date Data Was Run', value: getDisplayDate(data?.jobSubmittedTimestamp, DATE_FORMAT.MMM_D_YEAR) },
        { label: 'User Name', value: getDisplayValue(data?.accountName) },
    ];
}

export function prepareCvtPdfReport(data: CvtDiagnosticEntity, graphData: VehicleGraphData[]): PlotlyPdfExportOptions {
    const metaDetails = getCvtReportMetaDetails(data);
    const plotConfigs = graphData.length > 0 ? generateCvtPlotConfigs(graphData, true) : [];

    const fileName = data.fileName?.replace('.csv', '.pdf') ?? 'CVT_Diagnostic_Report.pdf';
    const sbrData = data.sbrData;

    const errorDetailLines = sbrData?.errorDetail?.split('\n').filter(Boolean) ?? [];

    return {
        columns: getSymptomsTablePdfColumns(),
        data: getSymptomsTablePdfData(data.sbrData?.symptoms ?? []),
        filename: fileName,
        tableTitle: PDF_TITLE,
        metaDetails,
        plotConfigs,
        repairRecommendation: sbrData?.repairRecommendation ?? [],
        errorDetail: errorDetailLines,
        errorType: sbrData?.errorType,
    };
}
